import { createStore } from 'solid-js/store';

type ChatInputs = Record<string, string | undefined>;

const [chatInputs, setChatInputs] = createStore<ChatInputs>({});

const generatePendingKey = (participantType: string, participantId: string) => {
  return `pending:${participantType}:${participantId}`;
};

export const setChatInput = (chatId: string, input: string) => {
  setChatInputs(chatId, input);
};

export const clearChatInput = (chatId: string) => {
  setChatInputs(chatId, undefined);
};

export const getChatInput = (chatId: string) => chatInputs[chatId] || '';

export const setPendingChatInput = (participantType: string, participantId: string, input: string) => {
  const pendingKey = generatePendingKey(participantType, participantId);
  setChatInputs(pendingKey, input);
};

export const getPendingChatInput = (participantType: string, participantId: string) => {
  const pendingKey = generatePendingKey(participantType, participantId);
  return chatInputs[pendingKey] || '';
};

export const clearPendingChatInput = (participantType: string, participantId: string) => {
  const pendingKey = generatePendingKey(participantType, participantId);
  setChatInputs(pendingKey, undefined);
};

export const migratePendingToChat = (participantType: string, participantId: string, chatId: string) => {
  const pendingKey = generatePendingKey(participantType, participantId);
  const pendingInput = chatInputs[pendingKey];

  if (pendingInput) {
    setChatInputs(chatId, pendingInput);
    setChatInputs(pendingKey, undefined);
  }
};

export const getInputForChat = (chatId: string | null | undefined, participantType?: string, participantId?: string | null) => {
  if (chatId) {
    return getChatInput(chatId);
  }

  if (participantType && participantId) {
    return getPendingChatInput(participantType, participantId);
  }

  return '';
};

export const setInputForChat = (
  input: string,
  chatId: string | null | undefined,
  participantType?: string,
  participantId?: string | null
) => {
  if (chatId) {
    setChatInput(chatId, input);
  } else if (participantType && participantId) {
    setPendingChatInput(participantType, participantId, input);
  }
};
